import React, { Component } from 'react';
import { Form } from 'react-form';
import TabElement from '../UI/Tabs';
import TextFields from '../UI/TextFiled';

class PromotionalCodesManagement extends Component {


    render() {

        const tabElements = [
            (
                <React.Fragment>
                    <div className="tab-content">

                        <div className="row flex-center-y justify-between mt-30">
                            <div className="col-xs-9">
                                <h1 className="color-grey">Personal Credit Codes</h1>
                            </div>
                            <div className="col-xs-3 text-right flex justify-end">
                                <button className="no-style min-120 pointer w-600 flex-center-y" onClick={ () => this.props.history.push('/user-relationship/new-personal-credit-codes') }>
                                    <i className="fa fa-plus-circle mr-5 font-md"></i> Create New Code
                                </button>
                            </div>
                        </div>

                        <div className="table withHover promotionalCodes mt-30">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Code</th>
                                        <th>Creation Date</th>
                                        <th>Expiry Date</th>
                                        <th>Discount</th>
                                        <th>Number of Users Using The Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr onClick={ () => this.props.history.push('/user-relationship/single-personal-credit-codes') }>
                                        <td>561</td>
                                        <td>02.05.18</td>
                                        <td>25.05.19</td>
                                        <td>50 SAR</td>
                                        <td>2</td>
                                    </tr>
                                    <tr onClick={ () => this.props.history.push('/user-relationship/single-personal-credit-codes') }>
                                        <td>561</td>
                                        <td>02.05.18</td>
                                        <td>25.05.19</td>
                                        <td>50 SAR</td>
                                        <td>2</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </React.Fragment>
            ),
            (
                <React.Fragment>
                    <div className="tab-content">

                        <div className="row flex-center-y justify-between mt-30">
                            <div className="col-xs-9">
                                <h1 className="color-grey">Promotional Codes</h1>
                            </div>
                            <div className="col-xs-3 text-right flex justify-end">
                                <button className="no-style min-120 pointer w-600 flex-center-y" onClick={ () => this.props.history.push('/user-relationship/new-promotional-codes') }>
                                    <i className="fa fa-plus-circle mr-5 font-md"></i> Create New Code
                                </button>
                            </div>
                        </div>

                        <div className="table withHover promotionalCodes mt-30">
                            <table>
                                <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Creation Date</th>
                                    <th>Expiry Date</th>
                                    <th>Discount</th>
                                    <th>Number of Users Using The Code</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr onClick={ () => this.props.history.push('/user-relationship/single-promotional-codes') }>
                                    <td>561</td>
                                    <td>02.05.18</td>
                                    <td>25.05.19</td>
                                    <td>50 SAR</td>
                                    <td>2</td>
                                </tr>
                                <tr onClick={ () => this.props.history.push('/user-relationship/single-promotional-codes') }>
                                    <td>561</td>
                                    <td>02.05.18</td>
                                    <td>25.05.19</td>
                                    <td>50 SAR</td>
                                    <td>3</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </React.Fragment>
            ),
            (
                <React.Fragment>
                    <div className="tab-content">

                        <div className="row flex-center-y justify-between mt-30">
                            <div className="col-xs-9">
                                <h1 className="color-grey">Signup Codes</h1>
                            </div>
                            <div className="col-xs-3 text-right flex justify-end">
                                <button className="no-style min-120 pointer w-600 flex-center-y" onClick={ () => this.props.history.push('/user-relationship/new-signup-codes') }>
                                    <i className="fa fa-plus-circle mr-5 font-md"></i> Create New Code
                                </button>
                            </div>
                        </div>

                        <div className="table withHover promotionalCodes mt-30">
                            <table>
                                <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Creation Date</th>
                                    <th>Expiry Date</th>
                                    <th>Discount</th>
                                    <th>Number of Users Using The Code</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr onClick={ () => this.props.history.push('/user-relationship/single-signup-codes') }>
                                    <td>561</td>
                                    <td>02.05.18</td>
                                    <td>25.05.19</td>
                                    <td>50 SAR</td>
                                    <td>2</td>
                                </tr>
                                <tr onClick={ () => this.props.history.push('/user-relationship/single-signup-codes') }>
                                    <td>561</td>
                                    <td>02.05.18</td>
                                    <td>25.05.19</td>
                                    <td>50 SAR</td>
                                    <td>3</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </React.Fragment>
            )

        ];

        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-9">
                                <h1 className="color-grey">Promotional Codes Management</h1>
                            </div>
                            <div className="col-xs-3">
                                <Form onSubmit={ this.submitted }>
                                    { formApi => (
                                        <form onSubmit={formApi.submitForm} className="search">
                                            <TextFields type="text" hintText="Search"/>
                                            <button className="no-style search-btn pointer">
                                                <i className="fa fa-search"></i>
                                            </button>
                                        </form>
                                    )}
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container box py-15">
                    <TabElement labels={['Personal Credit Codes', 'Promotional Codes', 'Signup Codes']}>
                        { tabElements }
                    </TabElement>
                </div>
            </React.Fragment>
        );
    }
}

export default PromotionalCodesManagement;



// WEBPACK FOOTER //
// ./src/components/User-relationship/PromotionalCodesManagement.js